import { Fragment, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';

import { Button, Col, Flex, Row, Spin, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import { formatDate } from 'helpers/date';
import NoDangerouslyHTML from 'v2/components/Shared/NoDangerouslyHTML';
import { useNewzzInfo } from 'v2/hooks/useNewzz';

import { openModalBF } from './modalBF';

interface IProps {
  notProductRecovering: number;
}

const InfoNewzz = ({ notProductRecovering }: IProps) => {
  const { newzzId } = useParams<{ newzzId: string }>();

  const { currentNewzz, isLoading } = useNewzzInfo(Number(newzzId));

  const handleClick = useCallback(() => {
    openModalBF(notProductRecovering);
  }, [notProductRecovering]);

  return (
    <div className='w-full'>
      <Link to='/producer/news/list'>
        <Icon.ChevronLeft  /> Voltar para news
      </Link>
      <Flex vertical justify='center' align='center'>
        {currentNewzz?.title && (
          <Typography.Title level={2} className='text-center'>
            {currentNewzz?.title}
          </Typography.Title>
        )}
        <Typography.Text type='secondary'>
          Publicado em: {formatDate(currentNewzz?.created_at, 'dd/MM/yyyy')}
        </Typography.Text>
      </Flex>

      {isLoading ? (
        <div className='flex h-full items-center justify-center py-8'>
          <Spin size='large' />
        </div>
      ) : currentNewzz ? (
        <Row justify='center' align='middle'>
          <Col xs={24} md={20} lg={20} className='rounded-1.25! p-6 [&_img]:mx-auto [&_img]:block [&_img]:max-w-full'>
            <NoDangerouslyHTML html={currentNewzz.content} />
            {(currentNewzz.id === 210 && notProductRecovering > 0) ||
              (true && (
                <Fragment>
                  <Col span={24}>
                    <p>
                      Se você tem interesse em ativar a opção de RECUPERAÇÃO DE VENDAS PERDIDAS em TODOS os seus
                      produtos, clique no link abaixo:
                    </p>
                  </Col>
                  <Col span={24}>
                    <Button
                      type='primary'
                      onClick={handleClick}
                      className='m-2 h-auto! w-full py-1! whitespace-normal!'
                      icon={<Icon.Smile className='mr-2'  />}
                      size='large'
                    >
                      QUERO ATIVAR A OPÇÃO DE RECUPERAÇÃO DE VENDAS PERDIDAS EM TODOS OS MEUS PRODUTOS
                    </Button>
                  </Col>
                </Fragment>
              ))}
          </Col>
        </Row>
      ) : null}
    </div>
  );
};

export default InfoNewzz;
